import { IQuestionConfig } from '../core/IQuestion';
import { IGenericQuestionProvider, IQuestionViewProps } from '../core/question-provider/IQuestionProvider';
import { MiniWizardViewModel } from '../core/MiniWizardViewModel';
import { Step } from '../../Step';
import { FC } from 'react';
import { IAvatarPhotoColor, PhotoAvatarOrColorPicker } from '../../../avatar/PhotoAvatarOrColorPicker';

const questionType = 'avatar' as const;
type IQuestionType = typeof questionType;

export type IAvatarQuestion = IQuestionConfig<IQuestionType, IAvatarPhotoColor>;

export class AvatarQuestionProvider implements IGenericQuestionProvider<IAvatarQuestion> {
    questionType = questionType;

    validate = (question: IAvatarQuestion) => {
        const answer = question.answer || {};
        return Boolean(answer.photo || answer.avatar || answer.color);
    };

    render = (question: IAvatarQuestion, wizard: MiniWizardViewModel) => {
        return <AvatarQuestionView question={question} wizard={wizard} />;
    };
}

export const AvatarQuestionView: FC<IQuestionViewProps<IAvatarQuestion>> = ({ question, wizard }) => {
    return (
        <Step
            question={question.questionTitle}
            subTitle={question.subTitle}
        >
            <PhotoAvatarOrColorPicker
                avatar={question.answer || {}}
                onAvatarChanged={change => {
                    wizard.answer(change);
                }}
            />

        </Step>
    );
};

